document.addEventListener('DOMContentLoaded', async () => { 
    const updateMetafield = async (customerId, collectionId) => {
        const response = await fetch('https://api.seoulbeautyclub.com/api/customer-update-collection', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                boxCollection: collectionId,
                customerId: customerId
            })
        });

        if (response.ok) {
            console.log('Metafield updated successfully');
        } else {
            console.error('Error updating metafield');
        }
    }

    const boxPicker = document.querySelector('.box-picker');
    let customerId = boxPicker.dataset.customerId;
    let boxPickerRadios = document.querySelectorAll('.box-picker__radio');
    let currentCollectionId = boxPicker.dataset.currentCollectionId;
    boxPickerRadios.forEach(function (radio) {
        if (radio.value === currentCollectionId) {
            radio.checked = true;
        }/*
        radio.addEventListener('change', function () {
            let collectionId = this.value;
            updateMetafield(customerId, collectionId);
        });*/
    });

    const confirmSelection = document.querySelector('.box-picker__header-confirm');
    confirmSelection.addEventListener('click', async () => {
        let selectedRadio = document.querySelector('.box-picker__radio:checked');
        if (selectedRadio) {
            let collectionId = selectedRadio.value;
            await updateMetafield(customerId, collectionId);
            confirmSelection.innerHTML = 'Updated Selection';
            setTimeout(() => {
                confirmSelection.innerHTML = 'Confirm Selection';
            }, 2000);
        }
    });

    let daysTillEndOfMonth = 0;
    let currentDate = new Date();
    let lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    daysTillEndOfMonth = lastDayOfMonth.getDate() - currentDate.getDate();

    let daysCount = document.querySelector('.box-picker__header-text--count');
    if (daysCount) {
        daysCount.innerHTML = `${daysTillEndOfMonth} days left`;
    }
});